/**
 * Controls the behaviour of component which relates to a scrolling position
 * @type {ScrollRelatedComponent}
 */
export default class ScrollRelatedComponent {
    constructor() {
        this.scrollRelatedElement = document.querySelector('[data-scroll-related]')

        if (this.scrollRelatedElement) {
            // set vars
            this.hiddenClass = 'scroll-related--hidden'
            // used to only touch classList when not or is shown
            this.isShown = false
            // Calculate the relative pageHeights factor to show from the configuration
            this.pageHeightsToScroll = this.scrollRelatedElement.dataset.scrollRelated / 100
            // scroll event for visibility of scroll to top btn
            window.addEventListener('scroll', () => this.handleScrolling())
        }
    }

    /**
     * hide or set visible class for scrolling related element
     */
    handleScrolling() {
        let currentScrollHeight = window.pageYOffset
        let maxScrollHeight = document.body.clientHeight
        let necessaryScrollHeight = window.innerHeight * this.pageHeightsToScroll

        // if necessary height is higher use 0.9 of maxScrollHeight as showing point
        if (necessaryScrollHeight > maxScrollHeight) {
            necessaryScrollHeight = (maxScrollHeight - window.innerHeight) * 0.9
        }

        let showComponent = currentScrollHeight >= necessaryScrollHeight
        if (showComponent && !this.isShown) {
            this.isShown = true
            this.scrollRelatedElement.classList.remove(this.hiddenClass)
        } else if (!showComponent && this.isShown) {
            this.isShown = false
            this.scrollRelatedElement.classList.add(this.hiddenClass)
        }
    }
}
